import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Grid } from '@material-ui/core';

// STYLES
import { Container } from './styles';

const BannerFMBResults = ({ title, subtitle, btnText, btnProps }) => {
  return (
    <Container className="banner-fmb section section--dark">
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={5} md={4}>
          {!!title && (
            <Typography className="banner-fmb__title" variant="h4">
              {title}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={7} md={5}>
          {!!subtitle && <Typography variant="body1">{subtitle}</Typography>}
        </Grid>
        <Grid item xs={12} md={3}>
          {!!btnText && (
            <div className="banner-fmb__btn-wrap">
              <Button className="banner-fmb__btn sizeExtraLarge" color="primary" {...btnProps}>
                {btnText}
              </Button>
            </div>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

BannerFMBResults.defaultProps = {
  title: '',
  subtitle: '',
  btnText: '',
  btnProps: {},
};

BannerFMBResults.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  btnText: PropTypes.string,
  btnProps: PropTypes.object,
};

export default React.memo(BannerFMBResults);
